import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { LoadingButton } from "@mui/lab";

import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { LOGIN } from "store/reducers/auth";
import { setUser } from "store/reducers/userSlice";
import { customAxios } from "components/axios/customAxios";
import { postLogin } from "components/axios/commonAxios";
import LogoImg from "components/LogoImg";

const LoginPage = () => {
    // const { getEnumValueByEnumName } = useEnumApi();
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            //console.log(1111);
            },
            message: alertMessage,
        });
    };

    const [loginId, setLoginId] = useState("");
    const [password, setPassword] = useState("");
    const [loginIdErrorText, setLoginIdErrorText] = useState("");
    const [passwordErrorText, setPasswordErrorText] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoginButton, setIsLoginButton] = useState(false);

    useEffect(()=>{
        const rememberMe = localStorage.getItem('rememberMe');
        const userId = localStorage.getItem('loginId');
        if (rememberMe) setRememberMe(JSON.parse(rememberMe));
        else setRememberMe(false)
        setLoginId(userId);
    },[]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoginButton(true);

        if (!loginId) {
            setLoginIdErrorText("Please enter email");
            setIsLoginButton(false);
            return;
        } else {
            setLoginIdErrorText("");
        }
        if (!password) {
            setPasswordErrorText("Please enter password");
            setIsLoginButton(false);
            return;
        } else {
            setPasswordErrorText("");
        }

        const data = new FormData(event.currentTarget);
        const rememberMe = data.get("rememberMe") ? true:false;
        localStorage.setItem('rememberMe' , rememberMe);
        localStorage.setItem('loginId', rememberMe ? data.get("loginId") : '');

        const userId   = data.get("loginId");
        const pwd  = data.get("password");

        let body = {
            login_id : userId,
            password : pwd,
        };

        loginProcess(body);
    };

    const loginProcess = async(body) => {
        await postLogin(body).then((res)=>{
            if (res.status && res.status === 200) {
                dispatch(LOGIN({accessToken:res.data.id_token, refreshToken:res.data.refresh_token}));
                // dispatch(LOGIN(res.data.id_token));
                // setClientHeaders(res.data.id_token);
                return res.data.id_token;
            }
            return null;
        }).then(async(result)=>{
            await customAxios.get('/api/users', {params : {loginId : body.login_id}}, {
                // headers: {
                //     Authorization: `Bearer ${result}`
                // }
            }).then((res) => {
               if (res.data && res.data._embedded) {
                //   console.log(res.data);
                  const userApi = res.data._embedded.users[0];
                //    console.log(userApi);
                    // let user = {loginId:userApi.loginId, name:userApi.name, role:userApi.role}
                    let user = {loginId:userApi?.loginId, name:userApi?.name}
                //    console.log(user);
                    dispatch(setUser(user));
                    navigate('/dashboard');
               }
            }).catch((err)=>{
                // console.log('user err');
                console.log(err);
                
                // handleAlertClick(err.response?.data?.message || err.message);
            });

            setIsLoginButton(false);
        }).catch((err)=>{
            console.log(err);
            setIsLoginButton(false);
            handleAlertClick(err.response?.data?.message || err.message);
        });
    }

    return (
        <div 
            className={`${platformServer !== 'NANTONG' ? 'login_box' : 'login_nt_box'}`}
            style={{
                minHeight: "100dvh",
            }}
        >
            <h1
                style={{
                    position: "absolute",
                    top: `${platformServer !== 'NANTONG' ? "30px" : "5px"}`,
                    left: "30px"
                }}
            >
                <Link to={'/'}><LogoImg /></Link>
            </h1>
            <div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        minHeight: "77dvh"
                    }}
                >
                    <Container component="main" maxWidth="xs">
                        <Box
                            sx={{  
                                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                                borderRadius: 2,
                                px: 4,
                                py: 6,
                                marginTop: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                backgroundColor: "#000"
                            }}
                        >
                            <Typography component="h1" variant="h5">
                                Sign in
                            </Typography>
                            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                                <TextField
                                    key={loginId}
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="loginId"
                                    label="ID"
                                    name="loginId"
                                    defaultValue={loginId}
                                    autoComplete="loginId"
                                    autoFocus
                                    error={!!loginIdErrorText}
                                    helperText={loginIdErrorText}
                                    onChange={e=>setLoginId(e.target.value)}
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    error={!!passwordErrorText}
                                    helperText={passwordErrorText}
                                    onChange={e=>setPassword(e.target.value)}
                                />
                                <FormControlLabel
                                    control={<Checkbox key={rememberMe} id="rememberMe" name="rememberMe" value="remember" color="primary" defaultChecked={rememberMe} />}
                                    label="Remember me"
                                />
                                <LoadingButton 
                                    type="submit" variant="contained" color="primary" 
                                    fullWidth
                                    sx={{ mt: 3, mb: 2 }}
                                    loading={isLoginButton} 
                                >
                                    Sign In
                                </LoadingButton>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        // alignItems: "center",
                                        // width: "100%",
                                    }}
                                >
                                    <Link style={{color:"#fff"}}>
                                    {/* ID/PW찾기 */}
                                    </Link>
                                    {/* {platformServer !== 'NANTONG' && <Link to={"/join/join"} style={{color:"#fff"}}>{t('message.common.title.company.write')}</Link>} */}
                                    <Link to={"/join/join"} style={{color:"#fff"}}>{t('message.common.title.company.write')}</Link>
                                </div>
                            </Box>
                        </Box>
                    </Container>
                </div>

                <div style={{marginLeft:"50px", width:"30%"}}>
                    <h2>{t('message.common.text.slogan.prediction.is.prevention')}</h2> 
                    <h4>{t('message.common.text.platform.introduction')}</h4>
                </div>

                <div 
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    {/* <h5><img src={`${process.env.PUBLIC_URL}/img/login_logo2.png`} alt='' /></h5>&nbsp;&nbsp;&nbsp;
                    <h5><img src={`${process.env.PUBLIC_URL}/img/login_logo1.png`} alt='' /></h5>  */}
                </div>
            </div>
        </div>
      )

}

export default LoginPage;